export var Modals;
(function (Modals) {
  Modals["noModal"] = "NO_MODAL";
  Modals["setPwdModal"] = "SET_PWD_MODAL";
  Modals["updatePwdModal"] = "UPDATE_PWD_MODAL";
  Modals["mailConfirmedPwdModal"] = "MAIL_CONFIRMED_PWD_MODAL";
  Modals["loginModal"] = "LOGIN_MODAL";
  Modals["menuUserModal"] = "MENU_USER_MODAL";
  Modals["signInModal"] = "SIGNIN_MODAL";
  Modals["signInModalWithMail"] = "SIGNIN_MODAL_WITH_MAIL";
  Modals["mailConfirmModal"] = "MAIL_CONFIRM_MODAL";
  Modals["mailConfirmedModal"] = "MAIL_CONFIRMED_MODAL";
  Modals["mailConfirmedModalError"] = "MAIL_CONFIRMED_MODAL_ERROR";
  Modals["passwordRecoveryModal"] = "PASSWORD_RECOVERY_MODAL";
  Modals["passwordRecoveryModalSent"] = "PASSWORD_RECOVERY_MODAL_SENT";
  Modals["contactModal"] = "CONTACT_MODAL";
  Modals["suggestionModal"] = "SUGGESTION_MODAL";
  Modals["valuation"] = "VALUATION_MODAL";
  Modals["valuationNotAvailableModal"] = "VALUATION_NOT_AVAILABLE_MODAL";
  Modals["saveSearchModal"] = "SAVE_SEARCH_MODAL";
  Modals["filtersModal"] = "FILTERS_MODAL";
  Modals["placeModal"] = "PLACE_MODAL";
  Modals["mapModal"] = "MAP_MODAL";
  Modals["filtersAgencyModal"] = "FILTERS_AGENCY_MODAL";
  Modals["listingTypologyMultiSelectModal"] = "LISTING_TYPOLOGY_MULTISELECT";
  Modals["ordersModal"] = "ORDERS_MODAL";
  Modals["filtersRealEstateInAgencyModal"] = "FILTERS_RE_AGENCY_MODAL";
  Modals["noteModal"] = "NOTE_MODAL";
  Modals["contactAgencySuccessModal"] = "CONTACT_AGENCY_SUCCESS_MODAL";
  Modals["agencyDetailModal"] = "AGENCY_DETAILS_MODAL";
  Modals["listingValuationTypology"] = "LISTING_VALUATION_TYPOLOGY";
  Modals["feedbackModal"] = "FEEDBACK_MODAL";
  Modals["tooltipModal"] = "TOOLTIP_MODAL";
  Modals["deleteUserModal"] = "DELETE_USER_MODAL";
  Modals["disclaimerModal"] = "DISCLAIMER_MODAL";
  Modals["agDisclaimerModal"] = "AG_DISCLAIMER_MODAL";
  Modals["deleteSsModal"] = "DELETE_SS_MODAL";
  Modals["areaOfInterestModal"] = "AREA_OF_INTEREST_MODAL";
  Modals["mailAlertOnFavouriteModal"] = "MAIl_ALERT_ON_FAVOURITE_MODAL";
  Modals["agencyAlertModal"] = "AGENCY_ALERT_MODAL";
  Modals["requestPrestigiousModal"] = "REQUEST_PRESTIGIOUS_MODAL";
  Modals["publishModal"] = "PUBLISH_MODAL";
  Modals["confirmDeleteFavoriteModal"] = "CONFIRM_FAVORITE_DELETE_MODAL";
  Modals["confirmDeleteAllFavoritesModal"] = "CONFIRM_DELETE_ALL_FAVORITES_DELETE_MODAL";
  Modals["updateProfileModal"] = "UPDATE_PROFILE_MODAL";
  Modals["updatePswConfirmModal"] = "UPDATE_PASSWORD_CONFIRM_MODAL";
  Modals["airaModal"] = "AIRA_MODAL";
  Modals["requestMrExample"] = "REQUEST_MR_EXAMPLE";
  Modals["filtersAuctionModal"] = "FILTERS_AUCTION_MODAL";
  Modals["consultantModal"] = "CONSULTANTS_MODAL";
  Modals["auctionVisitModal"] = "AUCTION_VISIT_MODAL";
  Modals["requestAttachmentsModal"] = "REQUEST_ATTACHMENTS_MODAL";
  Modals["consultantPhoneModal"] = "CONSULTANT_PHONE_MODAL";
})(Modals || (Modals = {}));